import {Card, Table, TableBody, TableContainer} from "@mui/material";
import {PATH_DASHBOARD} from "../../routes/path";
import {useLocales} from "../../locales";
import {TableHeadCustom, TableNoData, TablePaginationCustom, TableSkeleton} from "../../components/table";
import CommentsListTableToolbar from "../OperatorPreview/PreviewCommentsList/CommentsListTableToolbar";
import Scrollbar from "../../components/Scrollbar";
import CommentsListTableRow from "../OperatorPreview/PreviewCommentsList/CommentsListTableRow";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import {useCommentsHook} from "./useCommentsHook";
import ProcessingDialog from "../../components/ProcessingDialog";

const TABLE_HEAD = (translate) => [
    {id: "dateFrom", label: translate('dateFrom'), align: "left"},
    {id: "dateTo", label: translate('dateTo'), align: "left"},
    {id: "comment", label: translate('comment'), align: "left"},
    {id: "whoSee", label: translate('whoSee'), align: "left"},
    {id: "trip", label: translate('lineName'), align: "left"},
    {id: "departureTime", label: translate('departureTime'), align: "left"},
    {id: "operator", label: translate('carrier'), align: "left"},
    {id: "", sortable: false}
];

export default function CommentsPage({isPreview}) {
    const {translate} = useLocales();

    const {
        table,
        comments,
        loading,
        filters,
        isFiltered,
        tripTimes,
        operatorsBE,
        handleFilterChange,
        handleDepartureTimeChange,
        handleOperatorChange,
        handleResetFilters,
        handleDeleteRow,
        handleEditRow,
        handleSearch,
    } = useCommentsHook(isPreview);

    const {dense, page, order, orderBy, rowsPerPage, onSort, onChangeDense, onChangePage, onChangeRowsPerPage} = table;

    if (loading) {
        return <ProcessingDialog loading={loading}/>;
    }

    return (
        <PageHeaderWrapper
            titleKey={"commentsList"}
            headingKey={"commentsList"}
            links={[
                {name: translate('comments'), href: PATH_DASHBOARD.comments.list},
                {name: translate('list')}
            ]}
        >
            <Card>
                <CommentsListTableToolbar
                    isFiltered={isFiltered}
                    filters={filters}
                    tripTimes={tripTimes}
                    operatorsBE={operatorsBE}
                    onFilterChange={handleFilterChange}
                    onFilterDepartureTimeChange={handleDepartureTimeChange}
                    onOperatorChange={handleOperatorChange}
                    onResetFilter={handleResetFilters}
                    onSearch={handleSearch}
                />
                <TableContainer sx={{position: "relative", overflow: "unset"}}>
                    <Scrollbar>
                        <Table size={dense ? "small" : "medium"} >
                            <TableHeadCustom
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD(translate)}
                                rowCount={comments.content.length}
                                onSort={onSort}
                            />
                            <TableBody>
                                {loading && comments.content.length === 0
                                    ? Array.from({length: rowsPerPage}, (_, i) => (
                                        <TableSkeleton key={i} columns={TABLE_HEAD(translate).length}/>
                                    ))
                                    : comments.content.map((row) => (
                                        <CommentsListTableRow
                                            key={row.id}
                                            row={row}
                                            onEdit={() => handleEditRow(row)}
                                            onDelete={() => handleDeleteRow(row)}
                                        />
                                    ))}
                                <TableNoData isNotFound={!loading && comments.totalElements === 0}/>
                            </TableBody>
                        </Table>
                    </Scrollbar>
                </TableContainer>
                <TablePaginationCustom
                    count={comments.totalElements || 0}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={onChangePage}
                    onRowsPerPageChange={onChangeRowsPerPage}
                    dense={dense}
                    onChangeDense={onChangeDense}
                />
            </Card>
        </PageHeaderWrapper>
    );
}
